import { AxiosRestApplicationClient } from '@g2-shared/api-client/generated/money-transfer-app';
import { generateBaseAxiosClient } from '@g2-shared/common/libs/baseAxiosClient';

// @ts-ignore
const { VITE_APP_GATEWAY_BASE_URL } = import.meta.env;

const MoneyTransferApiClient = new AxiosRestApplicationClient(
  VITE_APP_GATEWAY_BASE_URL,
  generateBaseAxiosClient({ baseURL: VITE_APP_GATEWAY_BASE_URL })
);

interface IDIContext {
  MoneyTransferApiClient: AxiosRestApplicationClient;
}

export const DIContext: IDIContext = {
  MoneyTransferApiClient,
};
